@let showPrimaryComponent = showPrimaryComponent$ | async;
@let showSecondaryComponent = showSecondaryComponent$ | async;
@if (showPrimaryComponent || showSecondaryComponent) {
  <form [formGroup]="form">
    @let fieldsSettings = fieldsSettings$ | async;
    @if (showPrimaryComponent) {
      <ion-list lines="full" [inset]="true" class="no-last-line">
        <ion-list-header>Existing Primary Mortgage</ion-list-header>
        @if (fieldsSettings?.['mortgagePrimaryBalance']?.visible) {
          <ion-item>
            <ion-input
              redErrorMessage
              formControlName="mortgagePrimaryBalance"
              labelPlacement="stacked"
              placeholder="$"
              inputmode="decimal"
              type="text"
              [maskito]="amountMask"
              [maskitoElement]="maskPredicate"
            >
              <div slot="label" class="tw:whitespace-normal">Balance Left on Primary Mortgage</div>
            </ion-input>
          </ion-item>
        }
        @if (fieldsSettings?.['mortgagePrimaryInterestRate']?.visible) {
          <ion-item>
            <ion-input
              redErrorMessage
              formControlName="mortgagePrimaryInterestRate"
              labelPlacement="stacked"
              placeholder="%"
              inputmode="decimal"
              type="text"
              [maskito]="rateMask"
              [maskitoElement]="maskPredicate"
            >
              <div slot="label" class="tw:whitespace-normal">Interest % on Primary Mortgage</div>
            </ion-input>
          </ion-item>
        }
        @if (fieldsSettings?.['mortgagePrimaryPrepayPenalty']?.visible) {
          <ion-item>
            <ion-input
              redErrorMessage
              formControlName="mortgagePrimaryPrepayPenalty"
              labelPlacement="stacked"
              placeholder="$"
              inputmode="decimal"
              type="text"
              [maskito]="amountMask"
              [maskitoElement]="maskPredicate"
            >
              <div slot="label" class="tw:whitespace-normal">Prepayment Penalty</div>
            </ion-input>
          </ion-item>
        }
        @if (fieldsSettings?.['mortgagePrimaryLienCloseDate']?.visible) {
          <ion-item>
            <ion-input
              redErrorMessage
              formControlName="mortgagePrimaryLienCloseDate"
              labelPlacement="stacked"
              placeholder="mm/dd/yyyy"
              inputmode="text"
              type="text"
              (click)="onDatePickerInputClick($event)"
              [readonly]="true"
            >
              <div slot="label" class="tw:whitespace-normal">Existing Lien Close Date</div>
            </ion-input>
          </ion-item>
        }
      </ion-list>
    }

    @if (showSecondaryComponent) {
      <ion-list lines="full" [inset]="true" class="no-last-line">
        <ion-list-header>Existing Secondary Mortgage</ion-list-header>

        @if (fieldsSettings?.['mortgageSecondaryBalance']?.visible) {
          <ion-item>
            <ion-input
              redErrorMessage
              formControlName="mortgageSecondaryBalance"
              labelPlacement="stacked"
              placeholder="$"
              inputmode="decimal"
              type="text"
              [maskito]="amountMask"
              [maskitoElement]="maskPredicate"
            >
              <div slot="label" class="tw:whitespace-normal">Balance Left on Secondary Mortgage</div>
            </ion-input>
          </ion-item>
        }
        @if (fieldsSettings?.['mortgageSecondaryInterestRate']?.visible) {
          <ion-item>
            <ion-input
              redErrorMessage
              formControlName="mortgageSecondaryInterestRate"
              labelPlacement="stacked"
              placeholder="%"
              inputmode="decimal"
              type="text"
              [maskito]="rateMask"
              [maskitoElement]="maskPredicate"
            >
              <div slot="label" class="tw:whitespace-normal">Interest % on Secondary Mortgage</div>
            </ion-input>
          </ion-item>
        }
        @if (fieldsSettings?.['mortgageSecondaryPrepayPenalty']?.visible) {
          <ion-item>
            <ion-input
              redErrorMessage
              formControlName="mortgageSecondaryPrepayPenalty"
              labelPlacement="stacked"
              placeholder="$"
              inputmode="decimal"
              type="text"
              [maskito]="amountMask"
              [maskitoElement]="maskPredicate"
            >
              <div slot="label" class="tw:whitespace-normal">Prepayment Penalty</div>
            </ion-input>
          </ion-item>
        }
      </ion-list>
    }
  </form>
}
